import { useState, useEffect, useCallback } from "react";

type DeviceType = "mobile" | "tablet" | "desktop";

interface ResponsiveInfo {
  width: number;
  height: number;
  device: DeviceType;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
}

export function useResponsive(): ResponsiveInfo {
  const getDeviceType = useCallback((width: number): DeviceType => {
    if (width < 640) return "mobile";
    if (width < 1024) return "tablet";

    return "desktop";
  }, []);

  const getResponsiveInfo = useCallback((): ResponsiveInfo => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    const device = getDeviceType(width);

    return {
      width,
      height,
      device,
      isMobile: device === "mobile",
      isTablet: device === "tablet",
      isDesktop: device === "desktop",
    };
  }, [getDeviceType]);

  const [info, setInfo] = useState<ResponsiveInfo>(() => getResponsiveInfo());

  useEffect(() => {
    const handleResize = () => {
      setInfo(getResponsiveInfo());
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [getResponsiveInfo]);

  return info;
}
